export default __webpack_public_path__ + "static/media/Cultural.be4e12db.png";